const Footer = () => {
  return (
    <div className='flex justify-center pt-8 pb-16 text-gray-500'>
      <p>
        @2022 SohanEmon. All rights Reserved. Magento themes by bestmagentotheme
      </p>
    </div>
  );
};

export default Footer;
